import { Filter, Params } from 'types';

/*
ARCHIVAL_COLLECTION("Archivní fondy", Set.of(ArchivalEntityType.ARCHIVAL_COLLECTION)),
EAD_NODE_UNIT("Archivní popis / archiválie", Set.of(ArchivalEntityType.EAD_NODE, ArchivalEntityType.ARCHIVAL_UNIT)),
ARCHIVAL_AID("Archivní pomůcky", Set.of(ArchivalEntityType.ARCHIVAL_AID)),
ORIGINATOR("Rejstříková hesla", Set.of(ArchivalEntityType.ORIGINATOR)),
*/

export type SearchEntityType =
  | 'ARCHIVAL_COLLECTION'
  | 'EAD_NODE_UNIT'
  | 'ARCHIVAL_AID'
  | 'ORIGINATOR';

export enum SearchEntityEnum {
  ARCHIVAL_COLLECTION = 'ARCHIVAL_COLLECTION',
  EAD_NODE_UNIT = 'EAD_NODE_UNIT',
  ARCHIVAL_AID = 'ARCHIVAL_AID',
  ORIGINATOR = 'ORIGINATOR',
}

export const searchEntityTypeLabel: Record<SearchEntityEnum, string> = {
  ARCHIVAL_COLLECTION: 'Archivní fondy',
  EAD_NODE_UNIT: 'Archivní popis / archiválie',
  ARCHIVAL_AID: 'Archivní pomůcky',
  ORIGINATOR: 'Rejstříková hesla',
};

export type ParamsMap = Partial<Record<SearchEntityType, Filter[]>>;

export const searchEntityTypeList: SearchEntityType[] = [
  SearchEntityEnum.ARCHIVAL_COLLECTION,
  SearchEntityEnum.EAD_NODE_UNIT,
  SearchEntityEnum.ARCHIVAL_AID,
  SearchEntityEnum.ORIGINATOR,
];

export type InitialBody = {
  paramsMap: ParamsMap;
  cascadingParamsMap: ParamsMap;
};

export type PagingBody = {
  params?: Params;
  archivalAidIds?: string[];
  archivalCollectionIds?: string[];
  selectedEntityType: SearchEntityType;
};

export type InitialResultDto = {
  resultMap: Record<SearchEntityType, { count: number; ids: string[] }>;
};

export type HandlePagingParams = {
  paramsMap: ParamsMap;
  selectedEntityType: SearchEntityType;
  page: number;
  archivalCollectionIds?: string[];
  archivalAidIds?: string[];
  pageSize?: number;
};
